<template>
  <v-card>
    <v-toolbar
      class="px-4"
      style="
        background: linear-gradient(60deg, #66bb6a, #43a047);
        color: white;
        max-height: 64px;
      "
    >
      <span
        style="
          font-size: 1.125rem;
          line-height: 1.4em;
          font-weight: 300;
          font-size: 18px;
        "
        >#{{ item.intent }}</span
      >
      <v-spacer></v-spacer>
      <md-button
        @click="$emit('close-edit-dialog')"
        class="md-simple md-just-icon"
      >
        <md-icon>close</md-icon>
      </md-button>
    </v-toolbar>
    <v-card-text class="pa-0">
      <md-card-content>
        <form class="form-horizontal" action method="post">
          <div class="md-layout containerFlex">
            <div class="textLabel colorDark" style="margin-top: 12px;">
              {{ $t('intentCreate.name') }}
            </div>
            <div class="textLabel colorGrey">
              {{ $t('intentCreate.textName') }}
            </div>
            <md-field style="margin-top: 0;">
              <md-icon class="md-secundary">#</md-icon>
              <md-input
                v-model="intent.intent"
                :disabled="isNotCheckedOut"
                :placeholder="$t('intentCreate.nameLabel')"
              ></md-input>
            </md-field>
            <div class="textLabel colorDark" style="margin-top: 20px;">
              {{ $t('intentCreate.description') }}
            </div>
            <md-field style="margin-top: 0;">
              <md-input
                v-model="intent.description"
                :disabled="isNotCheckedOut"
                :placeholder="$t('intentCreate.descriptionLabel')"
              ></md-input>
            </md-field>
            <div class="textLabel colorDark" style="margin-top: 20px;">
              {{$t('editIntentDialog.userExample')}}
            </div>
            <md-field style="margin-top: 0;">
              <md-input
                v-model="exampleToAdd.text"
                :disabled="isNotCheckedOut"
                :placeholder="$t('editIntentDialog.forExampleIWantToPayMyCreditCardBill')"
              ></md-input>
            </md-field>
            <v-row no-gutters class="pa-0">
              <v-col cols="auto" style="margin-right: 8px;">
                <md-button
                  :disabled="exampleToAdd.text == '' ? true : false"
                  @click="addExample()"
                  class="md-facebook"
                >
                  <span>{{$t('editIntentDialog.add')}}</span>
                </md-button>
              </v-col>
              <!-- <v-col cols="auto">
                <md-button
                  :disabled="exampleToAdd.text == '' ? true : false"
                  class="md-github"
                >
                  <span>Mostrar recomendações</span>
                </md-button>
              </v-col> -->
            </v-row>
            <v-row no-gutters class="pa-0">
              <md-table
                :value="queriedData"
                md-sort="text"
                md-sort-order="asc"
                md-card
                :md-selected-value.sync="selected"
                class="table-striped paginated-table"
                style="padding: 12px; overflow: hidden;"
              >
                <md-table-toolbar>
                  <md-field>
                    <label for="pages">{{ $t('intentsList.perPage') }}</label>
                    <md-select
                      id="selectIndex"
                      v-model="pagination.perPage"
                      name="pages"
                    >
                      <md-option
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                      >
                        {{ item }}
                      </md-option>
                    </md-select>
                  </md-field>

                  <md-field>
                    <md-input
                      type="search"
                      class="mb-3"
                      clearable
                      style="width: 200px;"
                      :placeholder="$t('intentsList.search') + '...'"
                      v-model="searchQuery"
                    >
                    </md-input>
                  </md-field>
                </md-table-toolbar>

                <md-table-toolbar
                  slot="md-table-alternate-header"
                  slot-scope="{ count }"
                  style="position: relative;"
                >
                  <div class="backgroundRed md-toolbar">
                    <div class="md-toolbar-section-start">
                      {{ count }}
                      {{
                        count > 1
                          ? $t('intentsList.itemsSelected')
                          : $t('intentsList.itemSelected')
                      }}
                    </div>

                    <div class="md-toolbar-section-end">
                      <md-button
                        @click="deleteSelected()"
                        :disabled="isNotCheckedOut"
                        class="md-simple md-github"
                      >
                        <md-icon>delete</md-icon>
                        {{ $t('intentsList.delete') }}
                      </md-button>
                      <md-button
                        @click="clearSelection"
                        class="md-simple md-github"
                      >
                        <md-icon>cancel</md-icon>
                        {{ $t('intentsList.cancel') }}
                      </md-button>
                    </div>
                  </div>
                </md-table-toolbar>

                <md-table-row
                  :class="{ 'disable-click': isNotCheckedOut }"
                  slot="md-table-row"
                  slot-scope="{ item }"
                  :md-selectable="isNotCheckedOut ? undefined : 'multiple'"
                  @click="editExample(item)"
                >
                  <md-table-cell
                    :md-label="$t('editIntentDialog.add')"
                    md-sort-by="text"
                    >{{ item.text }}</md-table-cell
                  >
                  <!-- <md-table-cell md-label="Adicionado" md-sort-by="added">
                    <span style="margin-right: 24px;">{{ item.added }}</span>
                  </md-table-cell> -->
                </md-table-row>
              </md-table>
              <md-card-actions md-alignment="space-between">
                <div class="">
                  <p class="card-category">
                    {{
                      $t('intentsList.showingItems', {
                        from: from + 1,
                        to: to,
                        total: total,
                      })
                    }}
                  </p>
                </div>
                <pagination
                  class="pagination-no-border pagination-success"
                  v-model="pagination.currentPage"
                  :per-page="pagination.perPage"
                  :total="total"
                >
                </pagination>
              </md-card-actions>
            </v-row>
            <div style="width: 100%;">
              <div
                class="md-layout"
                style="width: 100%; justify-content: flex-end;"
              >
                <md-button
                  :disabled="isNotCheckedOut"
                  @click="$emit('save', intent)"
                  class="md-success"
                >
                  <span>{{$t('editIntentDialog.toSave')}}</span>
                </md-button>
              </div>
            </div>
          </div>
        </form>
      </md-card-content>
      <v-dialog v-model="editDialog" max-width="800px" persistent>
        <EditIntentExample
          ref="editExample"
          :value.sync="exampleToEdit.text"
          @close="editDialog = false"
        />
      </v-dialog>
    </v-card-text>
  </v-card>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import EditIntentExample from '@/components/EditIntentExample.vue'
import Fuse from 'fuse.js'
import clonedeep from 'lodash.clonedeep'
import Swal from 'sweetalert2'

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean
    }
  },
  components: {
    Pagination,
    EditIntentExample
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData () {
      // console.log(`examples`, this.intent)
      let result = this.intent.examples
      if (this.searchedData.length > 0) {
        result = this.searchedData
      }
      // console.log(`examples`, this.intent)
      return result.slice(this.from, this.to)
    },
    to () {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from () {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    total () {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.intent.examples.length
    },
    isNotCheckedOut () {
      return !this.$store.getters['snapshots/userCanEdit']
    }
  },
  data () {
    return {
      selected: [],
      intent: {},
      exampleToAdd: {
        text: ''
      },
      exampleToEdit: {
        text: ''
      },
      editDialog: false,
      currentSort: 'text',
      currentSortOrder: 'asc',
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['text'],
      searchedData: [],
      fuseSearch: null
    }
  },
  methods: {
    clearSelection () {
      this.selected = []
    },
    deleteSelected () {
      // console.log(`examples`, this.intent.examples, this.selected)
      this.intent.examples = this.intent.examples.filter(
        (value) => !this.selected.includes(value)
      )
      this.clearSelection()
    },
    editExample (example) {
      this.exampleToEdit = example
      this.editDialog = true
    },
    saveExample (example) {
      this.$set(this.exampleToEdit, 'text', example)
      this.editDialog = false
    },
    customSort (value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort
        if (this.currentSortOrder === 'desc') {
          return a[sortBy].localeCompare(b[sortBy])
        }
        return b[sortBy].localeCompare(a[sortBy])
      })
    },
    deleteRow (item) {
      let indexToDelete = this.intent.findIndex(
        (tableRow) => tableRow.id === item.id
      )
      if (indexToDelete >= 0) {
        this.intent.splice(indexToDelete, 1)
      }
    },
    addExample () {
      const hasExample = this.intent.examples.some(example => example.text.toUpperCase() === this.exampleToAdd.text.toUpperCase())
      if (hasExample) {
        Swal.fire({
          icon: 'error',
          title: `Intent example error`,
          text: this.$t('editIntentDialog.thisExampleIsAlreadyRegisteredInThisIntent'),
          showConfirmButton: true
        })
        return
      }

      this.intent.examples.push({ ...this.exampleToAdd })
    }
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery (value) {
      let result = this.intent.examples
      if (value !== '') {
        result = this.fuseSearch.search(this.searchQuery)
      }
      this.searchedData = result
    },
    watch: {
      item (newItem) {
        // console.log(`changed item`, newItem, this.item)
        this.intent = clonedeep(this.item)
      }
    }
  },
  beforeMount () {
    // console.log(`beforeMounted`)
    this.intent = clonedeep(this.item)
    this.fuseSearch = new Fuse(this.intent.examples, {
      keys: ['text'],
      threshold: 0.3
    })
  }
}
</script>

<style>
.md-menu-content.md-select-menu {
  z-index: 300 !important;
  width: 100%;
}
.v-toolbar__content > .md-button.md-simple i {
  color: white !important;
}
.md-field.md-theme-default:not(.md-focused) > .md-icon {
  color: rgba(0, 0, 0, 0.6) !important;
}
.textLabel {
  width: 100%;
  font-size: 14px;
  line-height: 24px;
}
.colorDark {
  color: #393939;
}
.colorGrey {
  color: rgba(111, 111, 111, 0.603);
}
.backgroundRed {
  background-color: rgba(255, 82, 82, 0.2) !important;
  border-radius: 0px !important;
  box-shadow: none !important;
  color: rgba(0, 0, 0, 0.87) !important;
  width: 100%;
  height: 56px;
  position: absolute;
  top: 0;
}
.backgroundRed:hover {
  color: rgba(0, 0, 0, 0.87) !important;
}
.inlineTitle {
  display: inline-block;
}
.rightJustify {
  position: absolute;
  right: 4px;
}
.disable-click {
  pointer-events: none;
}
</style>
